import {
  Box,
  Center,
  Divider,
  SkeletonText,
  Text,
  Link as ChakraLink,
  IconButton,
  Flex,
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLearningPlansAction } from 'store/modules/learningPlan/learningPlan-action';
import { ReducerStatus } from 'utils/constants';
import { v4 as uuidv4 } from 'uuid';

import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';

function NavigationContent({ id }) {
  const dispatch = useDispatch();

  const learningPlans = useSelector(
    (state) => state.learningPlan.learningPlans
  );

  const metaData = useSelector(
    (state) => state.learningPlan.learningPlansMetaData
  );

  const getLearningPlans = useSelector(
    (state) => state.learningPlan.getLearningPlans
  );

  const [page, setPage] = useState(1);

  useEffect(() => {
    dispatch(
      getLearningPlansAction({
        currentPage: page,
        pageSize: 18,
      })
    );
  }, [dispatch, page]);

  return (
    <>
      <Center>
        <Text px="6" fontSize="sm" color="grey.200" fontWeight={500} mb={3}>
          All Learning Plans
        </Text>
      </Center>
      <Divider mb={3} />
      <Box minH="70vh">
        {getLearningPlans.status === ReducerStatus.LOADING ? (
          <>
            {[...Array(18)].map(() => (
              <Box p={[0, 4]} key={uuidv4()} w="100%">
                <SkeletonText noOfLines={1} height="5px" />
              </Box>
            ))}
          </>
        ) : (
          learningPlans?.map((learningplan) => (
            <Box key={learningplan.id}>
              <Text
                px="6"
                fontSize="xs"
                fontWeight={learningplan.id.toString() === id ? 'bold' : '400'}
                color="grey.200"
                mb={3}
              >
                <ChakraLink
                  as={ReactRouterLink}
                  to={`/admin/learning-plans/${learningplan.id}`}
                >
                  {learningplan?.name}
                </ChakraLink>
              </Text>
              <Divider mb={3} />
            </Box>
          ))
        )}
      </Box>
      {getLearningPlans.status === ReducerStatus.SUCCEEDED &&
        metaData &&
        metaData?.totalItems !== learningPlans.length && (
          <Flex mt={5} mx={1} gap={2} justify="center" align="center">
            <IconButton
              size="sm"
              colorScheme="blue"
              isDisabled={page - 1 <= 0}
              aria-label="previous"
              onClick={() => setPage(page - 1)}
              icon={<ArrowBackIcon />}
            />

            <IconButton
              size="sm"
              colorScheme="blue"
              aria-label="next"
              isDisabled={!metaData?.hasNext}
              onClick={() => setPage(page + 1)}
              icon={<ArrowForwardIcon />}
            />
          </Flex>
        )}
    </>
  );
}

NavigationContent.propTypes = {
  id: PropTypes.number.isRequired,
};

export default NavigationContent;
